/**
 * @desc 进入Models信息编辑页面
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {
  /** Modelsid */
  id?: number
}

export function request(data: QueryParams): Promise<BaseResponse<defs.ResultBean<defs.Models>>> {
  return fetch({
    url: config.API_HOST + '/api/base/vehicleType/getDetail',
    params: data,
    method: 'GET',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
